export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_male_Hk.4d79af61.webp";